module.exports = __webpack_public_path__ + "media/ubud/goa_gajah_cave-58369170.jpg";